import React from 'react';

const formatDate = (raw) => {
  if (!raw) return null;
  const d = new Date(raw);
  if (Number.isNaN(d.getTime())) return null;
  return d.toLocaleString('en-US', {
    weekday: 'short',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  });
};

const parseTags = (tags) => {
  if (!tags) return [];
  if (Array.isArray(tags)) return tags.filter(Boolean);
  if (typeof tags === 'string') return tags.split(',').map(t => t.trim()).filter(Boolean);
  return [];
};

const WorkshopCard = ({ workshop, onOpen }) => {
  const title       = workshop.title || workshop.name || 'Untitled Workshop';
  const description = workshop.description || workshop.summary || 'No details provided yet.';
  const format      = workshop.location_type === 'virtual'
    ? 'Online'
    : workshop.location_name || workshop.location || 'In-person';
  const status      = (workshop.status || 'assigned').toString().toLowerCase();
  const thumbnail   = workshop.thumbnail_url || workshop.image_url || workshop.image || null;
  const startDate   = formatDate(workshop.start_datetime || workshop.startDate || workshop.date);
  const endDate     = formatDate(workshop.end_datetime || workshop.endDate);
  const tags        = parseTags(workshop.tags);

  return (
    <article className="wk-card wk-card-clickable" onClick={() => onOpen?.(workshop)}>

      {thumbnail && (
        <div className="wk-card-thumb">
          <img src={thumbnail} alt={title} className="wk-card-thumb-img" loading="lazy" />
        </div>
      )}

      <div className="wk-card-top">
        <span className={`wk-status wk-status-${status}`}>{status}</span>
        <span className="wk-format">{format}</span>
      </div>

      <h3 className="wk-card-title">{title}</h3>

      {(startDate || endDate) && (
        <div className="wk-card-dates">
          {startDate && (
            <span className="wk-card-date">
              <span className="wk-date-label">Start</span> {startDate}
            </span>
          )}
          {endDate && (
            <span className="wk-card-date">
              <span className="wk-date-label">End</span> {endDate}
            </span>
          )}
        </div>
      )}

      {tags.length > 0 && (
        <div className="wk-card-tags">
          {tags.map(tag => (
            <span key={tag} className="wk-tag">{tag}</span>
          ))}
        </div>
      )}

      <div className="wk-card-footer">
        {workshop.session_type && <span className="wk-tag">{workshop.session_type}</span>}
        <div className="wk-card-footer-right">
          <button
            type="button"
            className="ep-btn-ghost ep-btn-sm wk-open-btn"
            onClick={(e) => {
              e.stopPropagation();
              onOpen?.(workshop);
            }}
          >
            Open
          </button>
        </div>
      </div>
    </article>
  );
};

export default WorkshopCard;
